
export class JornadaJustificativaEntradaSaida {
  tipoRegistro: number;
  codigoJornada: number;
  dataInicio: Date;
  dataFim?: Date;
  JustificativaCheckin?: string;
  JustificativaCheckout?: string;
  codigoUsuario: number;
  nomeUsuario: string;
}
export class JornadaJustificativaTempoRegistro  {
  codigoJornada: number;
  justificativa: string;
}

export class JornadaJustificativaDistancia  {
  codigoJornada: number;
  justificativa: string;
}

export class FinalizaJornadaOutroDia  {
  cpf: string;
  data: Date;
}